module.exports = __webpack_public_path__ + "img/2022_dodge-charger.428237ee.png";